import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Organization, OrganizationClient, OrganizationToken, OrganizationTokenClient, UserClient, UserProfile, UserRoleTypes } from "src/app/web-api-client";
import { UserEditComponent } from "../user-edit/user-edit.component";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component"; 
import { OrganizationalTypes } from "../../../enums/organizational-types.enum";
import { NgbAlert, NgbModal, NgbToast } from "@ng-bootstrap/ng-bootstrap";
import { OrgTokenCreationComponent } from "./org-token-creation/org-token-creation.component";
import { Subject } from "rxjs";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-organization-token',
  templateUrl: './organization-token.component.html',
  styleUrls: ['./organization-token.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class OrganizationTokenComponent implements OnInit {

  public isLoaded: boolean = false;
  public OrganizationTypes: OrganizationalTypes;
  selectedOrganization: OrganizationToken;

  public orgId: number;
  public orgs: OrganizationToken[];

  // Assuming you already have a property for all the organizations
  public searchQuery: string = '';
  public filteredOrgs: OrganizationToken[] = []; 



  constructor(private readonly changeDetectionRef: ChangeDetectorRef, private toastr: ToastrService, private readonly modalService: NgbModal,public orgClient:OrganizationTokenClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  private loadData() {
    this.orgClient.getList(this.orgId).subscribe((orgs: OrganizationToken[]) => {
      this.isLoaded = false;
      this.orgs = orgs;
      this.filteredOrgs = orgs;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
  }


  public filterOrgs() {
    if (this.searchQuery) {
      this.filteredOrgs = this.orgs.filter(org =>
        org.title.toLowerCase().includes(this.searchQuery.toLowerCase()) 
      );
    } else {
      this.filteredOrgs = this.orgs;
    }
  }


 public onSelected(organization:OrganizationToken){
   if (this.isSelected(organization)){
    this.selectedOrganization = null;
  }
  else{

     this.selectedOrganization = organization;
  }
 }

  public isSelected(organization: OrganizationToken):boolean{
   return this.selectedOrganization == organization;
 }
  
  

public onCreation():void{

  let modalRef = this.modalService.open(OrgTokenCreationComponent, { size: 'xl', centered: true, backdrop: 'static' });
  modalRef.componentInstance.organizations = this.orgs;
  modalRef.componentInstance.orgId = this.orgId;
  modalRef.componentInstance.onClose.subscribe(r => {
    this.loadData();
  })

}


public onDelete(): void {

    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.orgClient.remove(this.selectedOrganization.id).subscribe(r => {
          this.modalService.open(SuccessModalComponent);
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }
   
  copyText(text: string, event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    navigator.clipboard.writeText(text).then(() => {

      this.toastr.success("Избраният текст е копиран", "Копирано", {
        timeOut: 3000,
        closeButton: true,
        positionClass: "toast-top-right",
      }); 
      // You can also implement a notification to the user that the text has been copied.
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }
}
